import { Routes, Route, Navigate } from "react-router-dom";
import { Spinner } from "@blueprintjs/core";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import { AppLayout } from "./layout/AppLayout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Blueprints } from "./pages/Blueprints";
import { BlueprintDetail } from "./pages/BlueprintDetail";
import { Leads } from "./pages/Leads";
import { CompanyDetail } from "./pages/CompanyDetail";
import { PeopleSearch } from "./pages/PeopleSearch";
import { Settings } from "./pages/Settings";

function ProtectedRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spinner size={40} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/dash" element={<Dashboard />} />
        <Route path="/blueprints" element={<Blueprints />} />
        <Route path="/blueprints/:id" element={<BlueprintDetail />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/companies/:id" element={<CompanyDetail />} />
        <Route path="/people-search" element={<PeopleSearch />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/dash" replace />} />
      </Route>
    </Routes>
  );
}

function PublicRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dash" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<PublicRoute />} />
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>
    </AuthProvider>
  );
}
